<template>
    <div>
        <b-card no-body>
            <b-card-header>
                <span class="h5">
                    Licitações
                </span>
            </b-card-header>
            <b-card-body>
            <div>
                <app-erros-box
                    :erros="erros"
                    v-if="erros.length > 0"
                ></app-erros-box>
                <app-tabela
                    :itens="licitacoes"
                    :campos="campos"
                    :itensPorPagina="itensPorPagina"
                    :bordered="false"
                    :small="false">
                    <template slot="botoes">
                        <b-button-group class="float-right">
                            <btn-inserir-licitacao
                                v-if="$temAcessoView('CONV-LIC-01')"
                                :convenio="convenio"
                                @atualizarLista="atualizarLista()">
                            </btn-inserir-licitacao>
                        </b-button-group>
                    </template>
                    <template slot="acoes" slot-scope="data">
                        <btn-atualizar-licitacao
                            class="text-danger float-left mr-1"
                            v-if="$temAcessoView('CONV-LIC-02')"
                            :convenio="convenio"
                            :licitacao="data"
                            @atualizarLista="atualizarLista()">
                        </btn-atualizar-licitacao>
                        <btn-documentos-licitacao
                            v-if="$temAcessoView('CONV-LIC-02')"
                            :convenio="convenio"
                            :licitacao="data"
                            @atualizarLista="atualizarLista()">
                        </btn-documentos-licitacao>
                        <btn-excluir-licitacao
                            class="text-danger float-left mr-1"
                            v-if="$temAcessoView('CONV-LIC-02')"
                            :convenio="convenio"
                            :licitacao="data"
                            @atualizarLista="atualizarLista()"
                        ></btn-excluir-licitacao>
                    </template>
                    <template slot="valor" slot-scope="data">
                        {{ data.valor | currency }}
                    </template>
                </app-tabela>
            </div>  
            </b-card-body>
        </b-card>
    </div>
</template>

<script>
import ConveniosServicos from '../ConveniosServicos'
import BtnInserirLicitacao from '../cadastro/licitacoes/BtnInserirLicitacao'
import BtnExcluirLicitacao from '../cadastro/licitacoes/BtnExcluirLicitacao'
import BtnAtualizarLicitacao from '../cadastro/licitacoes/BtnAtualizarLicitacao'
import BtnDocumentosLicitacao from '../cadastro/licitacoes/DocumentosLicitacao'

export default {
    props: {
        convenio: {
            type: Object,
            default: () => ({})
        }
    },

    components: {
        BtnInserirLicitacao,
        BtnAtualizarLicitacao,
        BtnExcluirLicitacao,
        BtnDocumentosLicitacao
    },

    data() {
        return {
            licitacoes: [],
            erros: [],
            mostrarTabela: false,
            campos: [
                {
                    key: 'cnpjFormatado',
                    label: 'CNPJ'
                },
                {
                    key: 'numeroProcesso',
                    label: 'Número do Processo'
                },
                {
                    key: 'nomeModalidade',
                    label: 'Modalidade'
                },
                {
                    key: 'objeto',
                    label: 'Objeto'
                },
                {
                    key: 'valorPrevistoFormatado',
                    label: 'Valor Previsto'
                },
                {
                    key: 'valorContratadoFormatado',
                    label: 'Valor Contratado'
                },
                {
                    key: 'numeroCertidao',
                    label: 'Número da Certidão'
                },
                {
                    key: 'acoes',
                    label: ''
                }
            ],
            itensPorPagina: 5
        }
    },

    methods: {
        atualizarLista(){
            this.$store.dispatch('addRequest')
            ConveniosServicos.obterPorId(this.convenio.idConvenio)
            .then(response => {
                if (response) {
                    if (response.success) {
                        this.licitacoes = response.data.licitacoes
                        this.$emit('atualizarDadosConvenio')
                    }
                    else{
                        this.erros = response.errors
                    }
                }
                this.$store.dispatch('removeRequest')
            })
        },
    },

    watch:{
        convenio(){
            if(this.convenio){
                this.licitacoes = this.convenio.licitacoes
            }
        },
    },
}
</script>